import React from 'react'
import { Modal, Button, Icon, List, Image, Divider, Grid } from 'semantic-ui-react'
import playbookImage from '../../../../../images/svg/noti-designer.svg'
import momentDateAndTime from '../../../../../helpers/momentDateAndTime'
import defaultLogo from "../../../../../images/logo/logo-80x50.png"
class ActivityDetailModal extends React.Component {



    close = () => {
        this.props.openDialog(false);
    }

    render() {
        let selectedActivity = this.props.activity ? this.props.activity : {}

        return (
            <Modal
                className="EditModalCard basicModal"
                open={this.props.isOpen}
                closeOnEscape={false}
                closeOnDimmerClick={false}
                size="tiny"
                closeIcon
                onClose={this.close}
            >
                <Modal.Header>
                    Activity Details
                </Modal.Header>
                <Modal.Content className="pad_0" scrolling>
                    <div style={{ padding: "10px 20px" }}>
                        <Grid columns={2}>
                            <Grid.Row className="pad_0">
                                <Grid.Column style={{ padding: "0 20px 0 0" }}>
                                    <List size="small" >
                                        <List.Item>
                                            <Image
                                                style={{
                                                    height: '26px',
                                                    margin: '0 8px 0 0 !important',
                                                    boxShadow: "0 0 2px 0 rgba(0,0,0,.4)"
                                                }}
                                                src={selectedActivity.accountId && selectedActivity.accountId.logo ? selectedActivity.accountId.logo : defaultLogo}
                                            />
                                            <List.Content>
                                                <span className="">Account </span>
                                                <List.Header>{selectedActivity.accountId && selectedActivity.accountId.name}</List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Grid.Column>
                                <Grid.Column style={{ padding: "0 20px 0 0" }}>
                                    <List size="small" >
                                        <List.Item>
                                            <Icon
                                                name="world"
                                                className="c-image-icon f_18 c-image-ws-icon"
                                            />
                                            <List.Content>
                                                <span className="">Workspace</span>
                                                <List.Header>
                                                    {selectedActivity.organizationId && selectedActivity.organizationId.name}
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <Grid columns={2}>
                            <Grid.Row className="pad_0">
                                <Grid.Column style={{ padding: "0 20px 0 0" }}>
                                    <List size="small" >
                                        <List.Item>
                                            <Image
                                                avatar
                                                src={selectedActivity.packId &&
                                                    selectedActivity.packId.createdBy &&
                                                    selectedActivity.packId.createdBy.profilePic}
                                            />
                                            <List.Content>
                                                <span className="">Playbook Owner</span>
                                                <List.Header>
                                                    {selectedActivity.packId &&
                                                        selectedActivity.packId.createdBy &&
                                                        selectedActivity.packId.createdBy.firstName}&nbsp;
                                                    {selectedActivity.packId &&
                                                        selectedActivity.packId.createdBy &&
                                                        selectedActivity.packId.createdBy.lastName}
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Grid.Column>
                                <Grid.Column style={{ padding: "0 20px 0 0" }}>
                                    <List size="small" >
                                        <List.Item>
                                            <List.Content>
                                                <span className="">Publishing Level</span>
                                                <List.Header >
                                                    <span className="clr-green">
                                                        {selectedActivity.packId &&
                                                            selectedActivity.packId.scope === "Public" ? "Public Library" : "Workspace Library"}
                                                    </span>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Icon
                                    name="tasks"
                                    className="c-image-icon f_16 "
                                    style={{ color: "#bdccd4" }} />
                                <List.Content className="c-image-icon-content" >
                                    <span className="">Activity Name</span>
                                    <List.Header>{selectedActivity.name}</List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Icon
                                    name="calendar alternate outline"
                                    className="c-image-icon f_16 "
                                    style={{ color: "#bdccd4" }} />
                                <List.Content className="c-image-icon-content" >
                                    <span className="">Created Date</span>
                                    <List.Header>{momentDateAndTime(selectedActivity.createdAt)}</List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Icon
                                    name="file alternate"
                                    className="c-image-icon f_16 "
                                    style={{ color: "#bdccd4" }} />
                                <List.Content className="c-image-icon-content" >
                                    <span className="">Category</span>
                                    <List.Header>
                                        {selectedActivity.packId &&
                                            selectedActivity.packId.baseCategory && selectedActivity.packId.baseCategory.name}
                                        <Icon name="chevron right" />
                                        {selectedActivity.packId &&
                                            selectedActivity.packId.category && selectedActivity.packId.category.name}
                                        <Icon name="chevron right" />
                                        {selectedActivity.packId &&
                                            selectedActivity.packId.subCategory && selectedActivity.packId.subCategory.name}
                                    </List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Icon
                                    name="clock outline"
                                    className="c-image-icon f_16 "
                                    style={{ color: "#bdccd4" }} />
                                <List.Content className="c-image-icon-content" >
                                    <span className="">Activity Duration</span>
                                    <List.Header>
                                        {selectedActivity.duration}
                                        {selectedActivity.duration === 0 || selectedActivity.duration === 1 ? " Day" : " Days"}
                                    </List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Image className="c-image-icon" src={playbookImage} />
                                <List.Content className="c-image-icon-content" >
                                    <span className="">Playbook Name</span>
                                    <List.Header>
                                        {selectedActivity.packId &&
                                            selectedActivity.packId.name}
                                    </List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Icon
                                    name="file alternate outline"
                                    className="c-image-icon f_16 "
                                    style={{ color: "#bdccd4" }} />
                                <List.Content className="c-image-icon-content" >
                                    <span className="">Description</span>
                                    <List.Header >
                                        {selectedActivity.description ?
                                            <div dangerouslySetInnerHTML={{ __html: selectedActivity.description }} /> :
                                            <span>No Description Added</span>
                                        }
                                    </List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>

                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content="Got it"
                        className="button-submit"
                        onClick={this.close}
                    />
                </Modal.Actions>
            </Modal >

        )
    }
}



export default ActivityDetailModal;